import React from 'react';

// Components
import BehavioralPatternGraph from 'Shared/components/BehavioralPatternGraph/BehavioralPatternGraph';
import BehavioralPatternShape from 'Shared/components/BehavioralPatternGraph/BehavioralPatternShape';

// Types
import {
  BAFactorShapeType,
  BehavioralPatternGraphType,
} from 'Shared/components/BehavioralPatternGraph/FactorShape.service';
import { BaPersonInfo } from 'Shared/types/BaInfo.types';

import './RelationshipSampleGraph.scss';

const RelationshipSampleGraph = () => {
  const baseClassName = 'RelationshipSampleGraph';

  const firstPersonBaPersonInfo: BaPersonInfo = {
    name: {
      first: 'Ana',
      last: 'Ramirez',
      middle: '',
      goesBy: '',
      prefix: '',
      suffix: '',
    },
    selfAssessmentScore: {
      aSigma: 0.75,
      bSigma: 1.1,
      cSigma: -1.72,
      dSigma: -0.44,
      eSigma: -0.7,
    },
    assessmentUserId: '123456',
    assessmentId: '789012',
    hasPendingBa: false,
  };
  const secondPersonBaPersonInfo: BaPersonInfo = {
    name: {
      first: 'Kay',
      last: 'Richards',
      middle: '',
      goesBy: '',
      prefix: '',
      suffix: '',
    },
    selfAssessmentScore: {
      aSigma: -2,
      bSigma: -1.72,
      cSigma: 1.09,
      dSigma: 1.5,
      eSigma: -1.07,
    },
    assessmentUserId: '1234656',
    assessmentId: '7890612',
    hasPendingBa: false,
  };
  const graphType = BehavioralPatternGraphType.Standard;

  return (
    <div>
      <div className={`${baseClassName}__relationship`}>Relationship</div>
      <div>
        <BehavioralPatternGraph
          graphType={graphType}
          baPersonInfo={firstPersonBaPersonInfo}
          otherBAPersonInfo={secondPersonBaPersonInfo}
          useConnectingLine={true}
          useBarDescriptions={false}
        />
      </div>
      <div className={`${baseClassName}__legend`}>
        {/* Separate spans are used so that if the UI is constrained for space, the `=` gets centered */}
        <div className={`${baseClassName}__legend-item`}>
          <BehavioralPatternShape graphType={graphType} shapeType={BAFactorShapeType.Circle} />
          <span>=</span>
          <span>Kay</span>
        </div>
        <div className={`${baseClassName}__legend-item`}>
          <BehavioralPatternShape graphType={graphType} shapeType={BAFactorShapeType.Square} />
          <span>=</span>
          <span>Ana</span>
        </div>
      </div>
    </div>
  );
};

export default RelationshipSampleGraph;
